import { memo } from 'react';

import { Row } from 'enable-ui';

import { InviteeGroup } from 'modules/calendar/components/InviteeGroup';
import { Invitee } from 'modules/calendar/core/type';

interface SelectedInviteesProps {
  trainers: {
    items: Invitee[];
  };
  clients: {
    items: Invitee[];
  };
  onRemoveInvitee: (invitee: Invitee) => () => void;
}

const SelectedInvitees = memo(({ trainers, clients, onRemoveInvitee }: SelectedInviteesProps) => {
  return (
    <Row direction="column" style={{ gap: 15 }}>
      {trainers.items.length > 0 && (
        <InviteeGroup
          title={`${trainers.items.length} trainers`}
          items={trainers.items}
          onRemoveInvitee={onRemoveInvitee}
        />
      )}

      {clients.items.length > 0 && (
        <InviteeGroup
          title={`${clients.items.length} clients`}
          items={clients.items}
          onRemoveInvitee={onRemoveInvitee}
        />
      )}
    </Row>
  );
});

export default SelectedInvitees;
